import { execSync } from 'node:child_process'
import as from 'ansis'
import { Command } from 'commander'

import { output } from '@/helpers/std-out'
import { getUpgradeInformation } from '@/helpers/upgrade'

const cmd = new Command('upgrade')

cmd.description('Upgrade current version of your cli')
cmd.action(async () => {
  const upgradeStatus = await getUpgradeInformation()

  if (!upgradeStatus.upgrade) {
    output.info().message('You are already up to date').print()
    return
  }

  output
    .info()
    .message(
      `Upgrading from ${upgradeStatus.currentVersion} to ${upgradeStatus.latestVersion}...`,
    )
    .print()

  try {
    // Use npm to upgrade the package globally
    execSync(`npm install -g ${upgradeStatus.name}@latest`, {
      stdio: 'inherit',
    })

    output.info().message('Successfully upgraded to the latest version').print()
  } catch {
    output
      .error()
      .title('Upgrade failed')
      .message('Failed to upgrade the CLI. Please try running:')
      .message(as.cyan(`npm install -g ${upgradeStatus.name}@latest`))
      .exit('error')
  }
})

export default cmd
